import { Avatar, AvatarStaticIcon, type AvatarSize } from "@/components/Avatar";
import type { FC } from "react";
import IconCuteRobotBase from "central-icons/IconCuteRobot";
import { withGitpodSize } from "@/assets/icons/utils";
import type { PropsWithClassName } from "@/components/podkit/lib/cn";

const IconCuteRobot = withGitpodSize(IconCuteRobotBase);

export const ServiceAccountAvatar: FC<PropsWithClassName<{ id: string; size?: AvatarSize }>> = ({
    id,
    size,
    className,
}) => {
    return (
        <Avatar size={size}>
            <AvatarStaticIcon identifier={id} size={size} className={className}>
                <IconCuteRobot className="shrink" size="sm" />
            </AvatarStaticIcon>
        </Avatar>
    );
};
